export default {
  header: 'Valikko',
  tabs: {
    menu: 'Valikko',
    modifier_groups: 'Lisävalinnat',
  },
  toasts: {
    failed_to_load_data: 'Valikon lataaminen epäonnistui. Päivitä sivu ja yritä uudelleen',
  },
};
